import React from 'react';

import styled from 'styled-components';

const HeaderContainer = styled.div`
  flex-shrink: 0;
  padding: 26px 64px 20px 29px;
  border-bottom: 1px solid var(--line-gray);
`;

const ModalTitle = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

const ModalTitleText = styled.div`
  font-size: 21px;
  font-family: var(--font-bold);
`;

const ModalSubtitle = styled.div`
  color: var(--text-secondary);
  font-size: 14px;
`;

type Props = {
  isEditing: boolean;
};

const CreateEditActionPlansModalHeader = ({ isEditing }: Props) => {
  const titleText = isEditing ? 'Edit Action Plan' : 'Create Action Plan';

  return (
    <HeaderContainer>
      <ModalTitle>
        <ModalTitleText>{titleText}</ModalTitleText>
        <ModalSubtitle>Add plan details and action items.</ModalSubtitle>
      </ModalTitle>
    </HeaderContainer>
  );
};

export default CreateEditActionPlansModalHeader;
